import { clsx } from '@alexis/helpers/clsx';
import { throttle } from 'lodash-es';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { scrollToTop } from '@helpers/utils';

import { getIsRtlState } from '@redux/selectors';

import BackToTopIcon from '../icons/back_to_top.svg';
import styles from '../styles/components/BackToTopButton.module.scss';
import Icon from './Icon';

interface BackToTopButtonProps {
  onScrollToTop?: () => void;
}

const BackToTopButton: React.FC<BackToTopButtonProps> = ({ onScrollToTop }) => {
  const [visible, setVisible] = useState(false);
  const isRtl = useSelector(getIsRtlState);

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      if (scrolled > 500) {
        setVisible(true);
      } else if (scrolled <= 500) {
        setVisible(false);
      }
    };

    const throttledToggleVisible = throttle(toggleVisible, 200);

    window.addEventListener('scroll', throttledToggleVisible);

    return () => window.removeEventListener('scroll', throttledToggleVisible);
  }, []);

  const handleScrollToTop = useCallback(() => {
    scrollToTop();
    onScrollToTop?.();
  }, [onScrollToTop]);

  return (
    <div
      className={clsx(styles.container, visible && styles.visible, isRtl && styles.isRtl)}
      onClick={handleScrollToTop}
    >
      <Icon src={BackToTopIcon} ariaLabel='Back to top' />
    </div>
  );
};

export default BackToTopButton;
